import HttpError from 'lib/HttpError';
import jwtDecode from 'jwt-decode';
import { fetchGigyaJWTPromise } from 'api/gigya';
import graphql from 'api/graphql';
import logger from 'util/logger';

function throwOnError(response) {
  if (!response.ok) {
    throw new HttpError(response.status, response.statusText);
  }
}

/**
 * Retriever a valid JWT to use for authenticated Triton streams
 * @private
 * @returns {string}
 */
export async function getTritonToken() {
  const TOKEN_KEY = 'juke_triton_jwt';
  let token;

  // Check if we have a valid stored token
  token = localStorage.getItem(TOKEN_KEY);

  if (token) {
    // Check if token is still valid
    const decodedToken = jwtDecode(token);

    if (typeof decodedToken.exp !== 'undefined' && Date.now() > decodedToken.exp * 1000) {
      logger.warn('[getTritonToken] Token has expired. Need to fetch new one.');

      localStorage.removeItem(TOKEN_KEY);
      token = undefined;
    } else {
      logger.info('[getTritonToken] Found a valid token in memory.', token);

      return token;
    }
  }

  const gigyaJWT = await fetchGigyaJWTPromise().catch((err) => {
    throw new Error('[getTritonToken] Failed to fetch Gigya JWT.', err);
  });

  const user = await graphql.fetchUser(gigyaJWT).catch((err) => {
    throw new Error('[getTritonToken] Failed to fetch user from Universal API.', err);
  });

  if (typeof user.tritonToken !== 'object') {
    throw new Error('[getTritonToken] Received a malformed token.');
  }

  // Save token
  // eslint-disable-next-line prefer-destructuring
  token = user.tritonToken.token;
  localStorage.setItem(TOKEN_KEY, token);

  return token;
}

/**
 * Get rating for jukeApp
 */
export async function fetchAppRating() {
  const response = await fetch(process.env.REACT_APP_RATING_SCRAPPER_ENDPOINT);
  throwOnError(response);
  return response.json();
}
